module.exports = __webpack_public_path__ + "static/commandforelement-5ca319e892350b07bc41f9a2c74f587c.png";